import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/arrow-down-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-93245906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-claim__info-section m-claim__header-information" }
const _hoisted_2 = { class: "m-claim__title" }
const _hoisted_3 = ["data-workspace", "data-subscribe-link"]
const _hoisted_4 = { class: "m-claim__media-container" }
const _hoisted_5 = { class: "m-claim__info-container" }
const _hoisted_6 = { class: "m-claim__info-section m-claim__claim-details" }
const _hoisted_7 = { class: "m-claim__info-section m-claim__claim-metadata" }
const _hoisted_8 = { class: "m-claim__metadata-button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, [
  /*#__PURE__*/_createTextVNode("View details "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_10 = {
  key: 1,
  class: "spinner",
  style: {"margin":"0 auto"}
}

import { computed } from 'vue';
import { StorageProtocol } from '@manifoldxyz/claim-contracts';
import { AddToCalendar } from '@manifoldxyz/vue-component-library';
import { StorageProtocolGateway } from '@/classes/claimExtensionContract';
import { ETHEREUM_NETWORK_NAMES } from '@/common/constants';
import ApproveSpendButton from '@/components/ApproveSpendButton.vue';
import BuyButton from '@/components/BuyButton.vue';
import ClaimSummary from '@/components/ClaimSummary.vue';
import CollectButton from '@/components/CollectButton.vue';
import Countdown from '@/components/Countdown.vue';
import Frame from '@/components/Frame.vue';
import PlatformLinks from '@/components/PlatformLinks.vue';
import Provenance, { Record } from '@/components/Provenance.vue';
import SignaturePromptButton from '@/components/SignaturePromptButton.vue';
import SpecialNetworkBanner from '@/components/SpecialNetworkBanner.vue';
import { abbreviate, abbreviateAddress } from '@/lib/claimUtil';
import { trackedGalleryContractLink } from '@/lib/telemetry';
import { SignatureSchema, useClaimStore } from '@/store/claimStore';
import CreateYourOwn from './CreateYourOwn.vue';
import ScribeIframe from './ScribeIframe.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScribeCompleteBody',
  setup(__props) {

const store = useClaimStore();

const provenanceRecords = computed<Record[]>(() => {
  const records: Record[] = [];
  // TODO: make storageprotocol aware
  if (store.metadataURL) {
    let protocol = 'Metadata';
    if (store.metadataURL.startsWith(StorageProtocolGateway[StorageProtocol.ARWEAVE])) {
      protocol = 'Arweave';
    } else if (store.metadataURL.startsWith(StorageProtocolGateway[StorageProtocol.IPFS])) {
      protocol = 'IPFS';
    }
    records.push({
      label: `${protocol} URL`,
      link: store.metadataURL,
      // can assert this exists since we have a url
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      value: abbreviate(store.metadataURL.split('/').pop()!),
    });
  } else {
    records.push({
      label: 'Metadata',
      link: '',
      value: 'On Chain',
    });
  }
  // contract addy next
  records.push({
    label: 'Contract Address',
    link: trackedGalleryContractLink(store.networkId, store.creatorContractAddress, {
      medium: 'provenance',
      campaign: 'scribe',
    }),
    value: abbreviateAddress(store.creatorContractAddress),
  });
  // token standard if it exists
  if (store.claimType) {
    records.push({
      label: 'Token Standard',
      value: store.claimType.toUpperCase(),
    });
  }
  // blockchain name
  records.push({
    label: 'Blockchain',
    value: ETHEREUM_NETWORK_NAMES[store.networkId],
  });

  // start/end dates
  if (store.startDate) {
    records.push({
      label: 'Start Date',
      value: store.startDate.toISOString().slice(0, 10),
    });
  }
  if (store.endDate && store.endDate.getTime() !== 0) {
    records.push({
      label: 'End Date',
      value: store.endDate.toISOString().slice(0, 10),
    });
  }
  return records;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, {
    class: _normalizeClass(["m-project m-claim__frame", { portrait: true }]),
    "no-overflow": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(store).name), 1),
        _createElementVNode("div", {
          "data-widget": "m-wallet-identity",
          class: "manifold-scheme-dark m-claim__artist-info",
          "data-workspace": _unref(store).creator.id,
          "data-subscribe-link": `https://app.manifold.xyz/c/${_unref(store).slug}?utm_source=subscribed_artist`
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(store).animation)
          ? (_openBlock(), _createBlock(ScribeIframe, {
              key: 0,
              class: "m-claim__media",
              src: _unref(store).animation
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(store).initialized)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(ClaimSummary, {
                  total: _unref(store).total,
                  "total-max": _unref(store).totalMax,
                  "has-allowlist": _unref(store).hasAllowlist
                }, null, 8, ["total", "total-max", "has-allowlist"]),
                (_unref(store).status === 'active' && _unref(store).endDate && !_unref(store).isSoldOut)
                  ? (_openBlock(), _createBlock(Countdown, {
                      key: 0,
                      class: "m-claim__countdown",
                      "end-date": _unref(store).endDate
                    }, null, 8, ["end-date"]))
                  : _createCommentVNode("", true),
                _createVNode(SpecialNetworkBanner),
                (_unref(store).erc20Address && _unref(store).erc20ApprovedSpend.lt(_unref(store).cost))
                  ? (_openBlock(), _createBlock(ApproveSpendButton, { key: 1 }))
                  : (
              _unref(store).signatureSchema == _unref(SignatureSchema).REDEMPTION_CODES &&
              !_unref(store).redemptionCodeValidated
            )
                    ? (_openBlock(), _createBlock(SignaturePromptButton, { key: 2 }))
                    : (_openBlock(), _createBlock(BuyButton, {
                        key: 3,
                        class: _normalizeClass({ 'm-claim__action-button': !_unref(store).hasSecondary })
                      }, null, 8, ["class"])),
                (_unref(store).hasSecondary)
                  ? (_openBlock(), _createBlock(CollectButton, {
                      key: 4,
                      class: _normalizeClass({ 'm-claim__action-button': _unref(store).hasSecondary })
                    }, null, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_unref(store).status === 'not-started' && _unref(store).startDate)
                  ? (_openBlock(), _createBlock(_unref(AddToCalendar), {
                      key: 5,
                      class: "add-to-calendar",
                      event: {
              title: `${_unref(store).name} claim starts`,
              description: _unref(store).description,
              start: new Date(_unref(store).startDate),
              duration: [1, 'hour'],
              location: `https://app.manifold.xyz/c/${_unref(store).slug}`,
            }
                    }, null, 8, ["event"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("details", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(Provenance, { records: provenanceRecords.value }, null, 8, ["records"])
                ]),
                _createVNode(PlatformLinks, {
                  class: "m-claim__metadata-button",
                  is1155: _unref(store).is1155,
                  "has-mints": _unref(store).total > 0,
                  "creator-contract-address": _unref(store).creatorContractAddress,
                  "token-id": _unref(store).tokenId
                }, null, 8, ["is1155", "has-mints", "creator-contract-address", "token-id"]),
                (_unref(store).metadataURL)
                  ? (_openBlock(), _createBlock(CreateYourOwn, {
                      key: 0,
                      class: "m-claim__metadata-button",
                      "instance-slug": _unref(store).slug ?? null,
                      "app-id": _unref(store).appId ?? null
                    }, null, 8, ["instance-slug", "app-id"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("i", _hoisted_10))
      ])
    ]),
    _: 1
  }))
}
}

})